import Hero from "@/components/Hero";
import Problem from "@/components/sections/Problem";
import Shift from "@/components/sections/Shift";
import MeetJack from "@/components/sections/MeetJack";
import Detector from "@/components/sections/Detector";
import { HowItWorks, AskJack } from "@/components/sections/HowAsk";
import Offers from "@/components/sections/Offers";
import { Different, Categories } from "@/components/sections/DifferentCategories";
import { Trust, Community } from "@/components/sections/TrustCommunity";
import { LeadMagnets, FAQ } from "@/components/sections/MagnetsFAQ";
import { FinalCTA, Footer } from "@/components/sections/FinalFooter";
import CinematicBand from "@/components/sections/CinematicBand";
// import JackCompanion from "@/components/JackCompanion";

function Home() {
  return (
    <>
      <Hero />
      <MeetJack />
      <Trust />
      <Different />
      <Problem />
      <Shift />
      <CinematicBand
        testId="band-case-room"
        img="/jack-caseroom.jpg"
        label="Step Inside"
        title={"Welcome to the\ncase room."}
        sub="Every confusing claim looks clearer under the right light."
        imgPositionClassName="object-[78%_center] lg:object-center"
      />
      <Detector />
      <HowItWorks />
      <AskJack />
      <Offers />
      <CinematicBand
        testId="band-storm"
        img="/jack-storm.jpg"
        label="Property & Disaster First"
        title="When the storm passes, the paperwork begins."
        sub="Jack reads what comes next"
        right
        imgPositionClassName="object-[25%_center] lg:object-center"
        heightClassName="h-[38vh] min-h-[380px] lg:h-[72vh] lg:min-h-[520px]"
      />
      <Categories />
      <Community />
      <LeadMagnets />
      <FAQ />
      <FinalCTA />
      <Footer />
      {/* <JackCompanion /> */}
    </>
  );
}

export default Home;
